import PaymentExportAllExportItem from '../Domain/PaymentExportAllExportItem.js';
import AuthService from './authService.js';
import SearchParams from '../Elements/SearchParams';
import PaymentExportAllExportSearchParams from '../Contents/Operations/PaymentExport/AllExport/PaymentExportAllExportSearchParams';

export default class PaymentExportAllExportService
{
  static GetListBySearching (orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false)
  {
    const searchParams = new SearchParams(searchItem, PaymentExportAllExportSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/Export/GetBySearchParams/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems (itemlist)
  {
    if (itemlist !== null)
    {
      return itemlist.map((item) => new PaymentExportAllExportItem(item));
    }
    return [];
  }

  static GetById (id)
  {
    const authService = AuthService.getInstance();
    const url = `/api/Export/GetById/${id}?clearCache=false`;
    return authService.CallBackendFunction(url);
  }

  static postUploadPaymentReconciliationFile (data)
  {
    const authService = AuthService.getInstance();
    const url = '/api/ExportPayment/PostPaymentReconciliationFile/';
    return authService.CallBackendFunctionPostFile(url, data);
  }

  static createDbBackup ()
  {
    const authService = AuthService.getInstance();
    const url = '/api/ExportPayment/CreateDbBackup/';
    return authService.CallBackendFunction(url);
  }

  static postValidatePaymentInformationFile (editedItem)
  {
    const data = new FormData();
    data.append('file', editedItem.file);
    data.append('exportId', editedItem.exportId);
    return AuthService.getInstance().CallBackendFunctionPostFile('/api/TpPaymentExport/ValidatePaymentInformation', data);
  }

  static postRequestPaymentDetailsReviewFile (editedItem)
  {
    const data = new FormData();
    data.append('file', editedItem.file);
    data.append('exportId', editedItem.exportId);
    return AuthService.getInstance().CallBackendFunctionPostFile('/api/TpPaymentExport/RequestPaymentDetailsReview', data);
  }

  static postXmlFile (data)
  {
    // console.log(data);
    const authService = AuthService.getInstance();

    // const url = '/api/Export/PostXmlFile/';
    const url = `/api/Export/PostXmlFile/${data.exportId}`;
    // console.log(url);
    // console.log(data);

    return authService.CallBackendFunctionPostFile(url, data);
  }
}
